<p-dialog
  [(visible)]="visible"
  [style]="{ width: '740px' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  (onHide)="onClose()"
  [header]="title">
  <ng-template pTemplate="content">
    <form [formGroup]="addActionForm">
      <div class="field col-12">
        <label for="reason">{{ 'common.label.reason' | translate }}</label>
        <textarea id="reason" class="w-full" pTextarea formControlName="reason"></textarea>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="justify-content-start flex">
      <button type="button" pButton label="{{ 'common.label.mark' | translate }}" (click)="HandleAction()"></button>
      <button
        (click)="onClose()"
        class="p-button-outlined"
        label="{{ 'common.button.cancel' | translate }}"
        pButton
        type="button"></button>
    </div>
  </ng-template>
</p-dialog>
